import React, { useEffect } from 'react';
import { getFilterRequest, revalidateChipSelection } from '@AMIEWEB/GlobalSearch/helper';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeOptionsEnum } from './Helper/Types';
import { PlacementChangeChips } from './Search/PlacementChangeChips';
import SearchGridWrapper from 'app/layout/pages/SearchGridWrapper';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import { GridTag, gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { useTranslation } from 'react-i18next';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { FormProvider, useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { PlacementChangeFacilityGrid } from './Search/Facilities/PlacementChangeFacilityGrid';
import { PlacementChangeOrdersGrid } from './Search/Orders/PlacementChangeOrdersGrid';
import { PlacementChangeFacilityFilter } from './Search/Facilities/PlacementChangeFacilityFilter';
import { PlacementChangeOrdersFilter } from './Search/Orders/PlacementChangeOrdersFilter';

export const PlacementChangeSearchDialog = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { selectedChangeOption, setSaveDisabled,setSearchResult } = props;
  const formMethods = useForm({ mode: 'all' });
  const [defaultOrderColumn] = React.useState<any>({ column: 'orderId', direction: 'desc' });
  const [defaultFacilityColumn] = React.useState<any>({ column: 'facilityId', direction: 'desc' });
  const gridState = useSelector(selectGridState);

  const onApplyFilter = (values, newFilterChips?) => {
    const filters = getFilterRequest(values, newFilterChips);
    const selectedChipFilters =
      newFilterChips || revalidateChipSelection(values, gridState.filterAttributes?.selectedChipFilters || []);
    dispatch(
      gridStateActions.setFilterAttributes({
        ...gridState.filterAttributes,
        filterObject: Object.entries(values),
        selectedChipFilters,
      }),
    );
    dispatch(gridStateActions.setPageNumber(1));
    dispatch(
      globalSearchActions.getSearchResults({
        searchType: selectedChangeOption === ChangeOptionsEnum.FacilityID ? SearchType.facility : SearchType.order,
        keyword: '',
        pageNumber: 1,
        pageSize: 250,
        sortedColumn:
          selectedChangeOption === ChangeOptionsEnum.FacilityID ? defaultFacilityColumn : defaultOrderColumn,
        filter: filters || {},
        translation: t,
      }),
    );
    setSaveDisabled(true);
  };

  useEffect(() => {
    dispatch(gridStateActions.setGrid(GridTag.PlacementChangeSearchGrid));
    setSearchResult(null);
    return () => {
      dispatch(gridStateActions.reset());
      dispatch(globalSearchActions.reset());
      dispatch(globalActions.closeBanner());
      dispatch(
        gridSelectionActions.setGridSelections({
          selectedData: [],
        }),
      );
    };
  }, []);

  return (
    <>
      <FormProvider {...formMethods}>
        <form>
          <Grid spacing={3} container>
            <Grid item xs={12}>
              {selectedChangeOption === ChangeOptionsEnum.FacilityID ? (
                <SearchGridWrapper
                  filters={<PlacementChangeFacilityFilter onApplyFilter={onApplyFilter} />}
                  chips={
                    <PlacementChangeChips selectedSearchType={SearchType.facility} onApplyFilter={onApplyFilter} />
                  }
                  table={<PlacementChangeFacilityGrid {...props} />}
                  loading={false}
                  tableMinHeight={538}
                />
              ) : (
                <SearchGridWrapper
                  filters={<PlacementChangeOrdersFilter onApplyFilter={onApplyFilter} />}
                  chips={<PlacementChangeChips selectedSearchType={SearchType.order} onApplyFilter={onApplyFilter} />}
                  table={<PlacementChangeOrdersGrid {...props} />}
                  loading={false}
                  tableMinHeight={538}
                />
              )}
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </>
  );
};
